export const FORMATS = {
  0: '0,0',
  1: '0,0.0',
  2: '0,0.00',
  3: '0,0.000',
  4: '0,0.0000',
  5: '0,0.00000',
  6: '0,0.000000'
}
